import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {discountInterface, discountSectionsInterface} from "./discounstInterface";
import DiscountCommon from "./discountCommon";
import {
  setDiscountSections,
  setFinanceActiveDiscount,
  setFinanceCellsVisible
} from "../../actions/priceWorksheetActions";
import {getDiscountSubTotalPrice, shouldUseMultipleWorkSheets} from "./discountFunctions";
import {getPriceWithCurrency} from "../../misc/helpers";

class DiscountSubTotal extends DiscountCommon {

  static propTypes = {
    discount: PropTypes.shape(discountInterface),
    discountSection: PropTypes.shape(discountSectionsInterface),
    shoppingCartItem: PropTypes.bool,
  };

  render() {

    const {discount, fabricatorSettings, discountSections, discountSection, shoppingCartItem, customAddedDiscounts,
      activeQuoteIndex, hasMultipleWorkSheets} = this.props;

    const {discountSubTotalWithTaxes} = getDiscountSubTotalPrice(
      discountSections, 
      discountSection,
      discount, 
      false, 
      customAddedDiscounts, 
      activeQuoteIndex,
      hasMultipleWorkSheets,
    );

    if (shoppingCartItem) {
      return getPriceWithCurrency(fabricatorSettings, discountSubTotalWithTaxes);
    }

    return (
      <li className="discount">
        <div className="discount-cell discount-cell--select">
          <button className={"ui-checkbox" + (discount.selected ? " ui-checkbox--checked" : "")}
                  onClick={this.handleDiscountSelectClick}/>
        </div>
        <div className="discount-cell discount-cell--name bold discount-cell--green" onClick={this.handleDiscountSelectClick}>
          {discount.selected ? discount.name : null}
        </div>
        {discount.selected ? (
          <div className="discount-cell discount-cell--amount bold discount-cell--green">
            {getPriceWithCurrency(fabricatorSettings, discountSubTotalWithTaxes)}
          </div>
        ) : null}
      </li>
    )
  }
}

const mapStateToProps = (store, ownProps) => {
  const {discountSections, customAddedDiscounts, workSheetsCount, financeCellsVisible, financeActiveDiscount} = store.priceWorksheetState;
  const {allWizardsValues} = store.wizardState;
  const {quotes, activeQuoteIndex} = store.quotesState;
  const {jobIsSaving} = store.serverState;

  return {
    discountSections,
    customAddedDiscounts,
    fabricatorSettings: store.fabricatorState.settings,
    fabricatorData: store.fabricatorState,
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    allWizardsValues,
    activeQuoteIndex: Number.isInteger(ownProps.quoteIndex) ? ownProps.quoteIndex : activeQuoteIndex,
    quotes,
    workSheetsCount,
    hasMultipleWorkSheets: shouldUseMultipleWorkSheets(workSheetsCount),
    jobIsSaving,
    financeCellsVisible,
    financeActiveDiscount,
  };
};

const mapDispatchToProps = {
  setDiscountSections,
  setFinanceCellsVisible,
  setFinanceActiveDiscount,
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountSubTotal);
